import React from "react";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import {Tooltip} from "@mui/material";
import {useTps} from "../../status/StatusContext";
import SpeedIcon from '@mui/icons-material/Speed';

const squareHighlightStyle = {
    width: '45px',
    height: '45px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0',
    padding: '0',
};

export default function TpsCounter() {

    const tpsCount = useTps();

    return (
        <>
            {tpsCount && tpsCount <= 15 ? <IconButton
                size="large"
                color="inherit"
                style={squareHighlightStyle}
            >
                <Badge badgeContent={tpsCount} color="warning">
                    <Tooltip title='Ticks Per Second'>
                        <SpeedIcon/>
                    </Tooltip>
                </Badge>
            </IconButton> : null}
        </>
    );
}